import { eliminarFile, subirFile } from "../../api/api-file";
import { sharedApiErrorMessage } from "../shared-functions";
import { buildFileUploadPayload, isRemoteImageUrl } from "./image-file-utils";

export async function uploadRasterImage(file, compressedDataUrl, t) {
    const payload = buildFileUploadPayload(file, compressedDataUrl);
    const response = await subirFile(payload);
    if (response.error) {
        throw new Error(sharedApiErrorMessage(response.message, t("alert_process_failed")));
    }
    return response.body;
}

export async function deleteRemoteImageIfNeeded(imageUrl, t) {
    if (!isRemoteImageUrl(imageUrl)) {
        return;
    }
    const response = await eliminarFile({ url: imageUrl });
    if (response.error) {
        throw new Error(sharedApiErrorMessage(response.message, t("alert_process_failed")));
    }
}
